import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Bloquea rutas que requieren un username definitivo.
 * Los usuarios que se registraron con Google reciben un username temporal
 * y deben configurarlo antes de acceder a funciones de escritura.
 *
 * Siempre debe ir DESPUÉS de authGuard en la cadena:
 *   canActivate: [authGuard, usernameGuard, verifiedGuard]
 *
 * Nota: NO aplica a las rutas /verify-email ni /setup-username.
 */
export const usernameGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.requiresUsername()) {
    return router.createUrlTree(['/setup-username']);
  }

  return true;
};
